import Vue from 'vue';
import Vuex from 'vuex';

// Vuex Modules
import contacts from '@/store/modules/contacts.js';
import spreadsheetFormats from '@/store/modules/spreadsheetFormats.js';
import timeEntry from '@/store/modules/timeEntry.js';
import fieldOperations from './modules/fieldOperations.js';
import quarterlyEvaluations from './modules/quarterlyEvaluation.js';
import trainingVideos from './modules/trainingVideo.js';
import utils from './modules/utils.js';

//
import * as checklists from '@/store/modules/field_operations/checklists.js';
import * as improvementRequests from '@/store/modules/improvementRequests.js';
import * as notifications from '@/store/modules/notificationsModule.js';
import * as users from '@/store/modules/users.js';

// CRM store modules
import * as contracted from '@/store/modules/customer_relationships_management/contracted.js';
import * as designs from '@/store/modules/customer_relationships_management/designs.js';
import * as facilities from '@/store/modules/customer_relationships_management/facilities.js';
import * as opportunities from '@/store/modules/customer_relationships_management/opportunities.js';
import * as preContracting from '@/store/modules/customer_relationships_management/preContracting.js';
import * as projectEngines from '@/store/modules/customer_relationships_management/projectEngines.js';
import * as salesforceContacts from '@/store/modules/customer_relationships_management/salesforceContacts.js';
import * as services from '@/store/modules/customer_relationships_management/services.js';
import * as sops from '@/store/modules/customer_relationships_management/sops.js';
import * as workOrders from '@/store/modules/customer_relationships_management/workOrders.js';
import departments from '@/store/modules/departments';
import projectFinance from '@/store/modules/projectFinance';
import projectFinanceGroupTotals from '@/store/modules/projectFinanceGroupTotals';
import projectFinanceServices from '@/store/modules/projectFinanceServices';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    fieldOperations,
    utils,
    timeEntry,
    contacts,
    spreadsheetFormats,
    improvementRequests,
    notifications,
    users,
    quarterlyEvaluations,
    trainingVideos,
    checklists,
    departments,
    projectFinance,
    projectFinanceServices,
    projectFinanceGroupTotals,

    // CRM migration modules
    facilities,
    salesforceContacts,
    opportunities,
    designs,
    services,
    projectEngines,
    preContracting,
    contracted,
    sops,
    workOrders,
  },
  state: {
    recentOpportunities: [],
    selectedIndex: '',
    spaceId: '',
    opportunityId: '',
    designId: '',
    selectProductId: '',
    productAddedTODesignBox: false,
    returnToDesignManualPopup: false,
    returnToAllExPopup: false,
    returnToMissingData: false,
    goToInstallationPage: false,
    goToDesignsPage: false,
    selectedDesign: '',
    selectedDesignSpaceId: '',
    selectedExistingCode: '',
    spaceID_ECM: '',
    ECMData: { ecmType: '', p1: '', p2: '', c1: '', c2: '', c3: '', a1: '', a2: '', a3: '' },
    returnToECM: false,
    // Edit ECM data
    returnToECMEdit: false,
    editSelectedECMLineNumber: '',
    editECMData: { ecmType: '', p1: '', p2: '', c1: '', c2: '', c3: '', a1: '', a2: '', a3: '' },
  },
  mutations: {
    update_selected_index(state, index) {
      state.selectedIndex = index;
    },
    design_url_ids(state, ids) {
      state.spaceId = ids.spaceId;
      state.opportunityId = ids.opportunityId;
      state.designId = ids.designId;
      console.log('Design ID = ' + state.designId);
    },
    reset_state(state) {
      state.selectedIndex = '';
      state.spaceId = '';
      state.opportunityId = '';
    },
  },
  actions: {
    updateSelectedIndex({ commit }, index) {
      commit('update_selected_index', index);
    },
    resetState({ commit }) {
      commit('reset_state');
    },
  },
});
